import * as React from "react";

const RightIconOutlineRegularIcon = ({ color = "#1F1F1F", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.0155 4.76528L6.26552 8.51528C6.23069 8.55014 6.18934 8.5778 6.14381 8.59667C6.09829 8.61555 6.04949 8.62526 6.00021 8.62526C5.95093 8.62526 5.90213 8.61555 5.85661 8.59667C5.81108 8.5778 5.76972 8.55014 5.7349 8.51528L1.9849 4.76528C1.91453 4.69491 1.875 4.59948 1.875 4.49996C1.875 4.40045 1.91453 4.30502 1.9849 4.23465C2.05526 4.16429 2.1507 4.12476 2.25021 4.12476C2.34972 4.12476 2.44516 4.16429 2.51552 4.23465L6.00021 7.71981L9.4849 4.23465C9.51974 4.19981 9.5611 4.17217 9.60662 4.15332C9.65214 4.13446 9.70094 4.12476 9.75021 4.12476C9.79948 4.12476 9.84827 4.13446 9.8938 4.15332C9.93932 4.17217 9.98068 4.19981 10.0155 4.23465C10.0504 4.26949 10.078 4.31086 10.0969 4.35638C10.1157 4.4019 10.1254 4.45069 10.1254 4.49996C10.1254 4.54924 10.1157 4.59803 10.0969 4.64355C10.078 4.68907 10.0504 4.73044 10.0155 4.76528Z"
      fill={color}
      style={{
        fill: { color },
        fillOpacity: 1
      }}
    />
  </svg>
);
export default RightIconOutlineRegularIcon;
